import bckdivS from '../spritesheets/bckdivS.png';
import { useContext } from 'react';
import { EnteredContext } from '../context/EnteredContext';

export default function MobileSign(props) {
  const { entered, disabled, setDisabled, setSelected } = useContext(EnteredContext);

  return (
    <div
      className={`md:hidden absolute my-4 w-[320px] h-[86px] flex flex-col text-center justify-center items-center ${props.animated} animate__bounceInLeft`}
      style={{
        backgroundImage: `url(${bckdivS})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}>
      <div className="text-3xl">{entered}</div>
    </div>
  );
}
